import { upgradedDeepGet } from "../../../../../features/dataFunctions/dataFunctions";

export function defaultBodyTemplate(rowData: any, field: any, valueFormat?: any) {
    const data = upgradedDeepGet(rowData, field, valueFormat)
    return (
        <div>
            {data != null
                ?
                <span>{data}</span>
                :
                <div>—</div>
            }
        </div>
    );
}